import React, {Component} from 'react';
import styles from './DetailsSection.module.css';

class DetailsSection extends Component {

    constructor(props){
        super(props);
        this.renderTitle = this.renderTitle.bind(this);
    }

    renderTitle() {
        if(this.props.title){
            return (
                <div className={styles.titleContainer}>
                    <h4 className="h4Bold">{this.props.title}</h4>
                </div>
            );
        }
    }

    render() {
        let divider;
        if(this.props.divider){
            divider = styles.sectionDivider;
        }

        return (
            <div className={[styles.section, divider].join(' ')}>
                {this.renderTitle()}
                {this.props.children}
            </div>
        );
    }

}

export default DetailsSection;